/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, centerAbsolutely } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED IFRAME : STYLES --------------- ++++++++++ */
export default theme => ({
	embediframe: {
		width: '100%',
		height: '100%',
		'& #insticator-container, #insticator-embed, #insticator-iframe': {
			width: '100%'
		},
		'& #insticator-embed': {
			height: pxToEm(350),
			'& #insticator-iframe': {
				height: '100% !important'
			}
        },
		'& .rail': {
            order:'0 !important',
		},
		'& #div-insticator-ad-1, #div-insticator-ad-2': {
			background: theme.color.neutral.medium.swatch,
			width: pxToEm(300),
			height: pxToEm(250), // 250 is real height (need some design adjustments to figure out how to fit this)
			position: 'relative',
			'& .desc': {
				color: theme.color.dark.dark.swatch,
				fontSize: pxToEm(20),
				extend: centerAbsolutely
			}
		}
	}
});
